import React, {useEffect, useState} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import {ApolloContext} from "../../atom/Apollo_Context";
import { 
  apollo_billing_prices,
} from "../../atom/Apollo_links";
import {BillingReport} from "../../pages/INVOICE/InVoiceModel";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
// メッセージ定義
import {
  GetMessage,
  UI_INVOICE_DOWNLOAD,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import {Button} from "@material-ui/core";

const dataToCsvBlob = (data: any[][], header: any[]): Blob => {
  // const body = [header].concat(data)
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
  // const csvData = body?.map(line => line.join(',')).join('\r\n');
  var csvData = "";
  header?.map((column, index1) => {
    if (index1 > 0) {
      csvData = csvData + ",";
    }
    // ダブルクォーテーション化
    var columnWork = column;
    if (typeof column === "string") {
      columnWork = column.replace(/"/g, '""');
    }
    csvData = csvData + '"' + columnWork + '"';
  });
  csvData = csvData + "\r\n";

  data?.map((line, index1) => {
    line?.map((column, index2) => {
      if (index2 > 0) {
        csvData = csvData + ",";
      }
      if (index2 > 11 && column !== "" && column !== "-") {
        csvData = csvData + '"\\' + Number(column).toLocaleString() + '"';
      } else {
       // ダブルクォーテーション化
        var columnWork = column;
        if (typeof column === "string") {
          columnWork = column.replace(/"/g, '""');
        }
        csvData = csvData + '"' + columnWork + '"';
      }
      return csvData;
    });
    csvData = csvData + "\r\n";
  });
  // csvData = head + csvData;

  const blob = new Blob([bom, csvData], {
    type: 'text/csv'
  })
  return blob
}

/*
    確定請求金額ダウンロード
 */
const ApolloInVoiceDownload = (props: {accountGroupId: number, year: string, month: string, billingType: number, disabledButton: boolean}) => {
  const {accountGroupId, year, month, billingType, disabledButton} = props;
  const {data, setmsg} = React.useContext(ApolloMessage);
  // const [rows, setRows] = useState<BillingReport[]>([]);
  const [download, setDownload] = useState(0);
  const {state} = React.useContext(ApolloContext)
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  useEffect(() => {
    if (download === 0) return; 
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    const url = apollo_billing_prices + "/" + accountGroupId + "/" + year + "/" + month + "/" + billingType;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        // setRows(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
        createCsv(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_INVOICE_DOWNLOAD,"E","0"),
            loading: false
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_INVOICE_DOWNLOAD,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [download]);

  // ダウンロードハンドラ
  const handleDownload = () => {
    setDownload(download+1);
  }

  // 
  const createCsv = (rows:BillingReport[]) => {
    let billingArray = rows.map((row) => {
      return [
        row.accountGroupId,
        row.accountGroupName,
        row.billingResourceId,
        row.billingResourceName,
        // row.platformAccountId,
        row.accountId,
        row.advertiserName,
        row.platformAccountName,
        row.menuName,
        row.campaignKindName,
        row.month,
        row.startAt,
        row.endAt,
        row.budgetAmount,
        row.platformBudget1Amount,
        row.price,
      ]
    });

    if (!billingArray) {
      billingArray = [[]]
    }
    const csvHeader = [
      "アカウントグループID",
      "広告会社名",
      "請求リソースID",
      "請求リソース名",
      "広告主アカウントID",
      "広告主名",
      "広告主アカウント名",
      "メニュー名",
      "キャンペーン種別",
      "対象年月",
      "期間開始日",
      "期間終了日",
      "アカウント月額予算",
      "メニュー別月額予算",
      "確定金額",
    ]

    // monthの0埋め
    const stringMonth = ("0" + month).slice(-2)
    const yearMonth = year + stringMonth

    const blob = dataToCsvBlob(billingArray, csvHeader)
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    // CSVファイル名決定
    link.download = 'test.csv';
    var fileName01 = "アカウントグループ名なし";
    var billingTypeName = "運用型";
    if (rows.length > 0 && rows[0].accountGroupName !== "") fileName01 = rows[0].accountGroupName;
    if (state.userprofile.systemAdmin) fileName01 = "確定請求金額";
    if (billingType === 2) billingTypeName = "予約型";
    link.download = `${fileName01}(${billingTypeName})_${yearMonth}.csv`;
    link.click();
  }

  // 画面表示
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleDownload}
        style={{whiteSpace:"nowrap"}}
        disabled={disabledButton}
        >
        請求CSVダウンロード
      </Button>
    </div>
  );
}
export default ApolloInVoiceDownload;
